<template>
  <v-row align="center" no-gutters>
    <v-col cols="4">
      <v-list-item class="ml-n4">
        <v-list-item-avatar>
          <v-img :src="avatar_img"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ nome[0] }}
          </v-list-item-title>
          <v-list-item-subtitle :class="prodotto.a_vaso ? 'amber--text':''" v-if="nome[1] != ''">
            {{prodotto.a_vaso ? 'Vaso Singolo' : nome[1] }}
          </v-list-item-subtitle>
          <v-list-item-subtitle> {{prodotto.a_vaso ? (prezzo_prodotto / prodotto_raw.unita).toFixed(2) : prezzo_prodotto.toFixed(2) }} € </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-if="ordine" cols="2"
      ><span style="font-size: 16px">{{
        prodotto.qta_ordine ? prodotto.qta_ordine : 0
      }}</span>
      <br />
      <span class="grey--text">{{ tot_ordinato.toFixed(2) }} €</span></v-col
    ><v-col v-else cols="2"></v-col>
    <v-col cols="2"
      ><span style="font-size: 16px">{{ prodotto.qta_contata }}</span> <br />
      <span class="grey--text">{{ tot_conteggiato.toFixed(2) }} €</span></v-col
    >
    <v-col v-if="ordine" cols="3">
      <v-list-item two-line class="ml-0">
        <v-list-item-avatar>
          <v-icon :color="discrepanza.color" size="" class="">{{
            discrepanza.icon
          }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title :class="discrepanza.color + '--text'">
            {{ discrepanza.qta }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ tot_discrepanza.toFixed(2) }} €
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-else cols="3"></v-col>
    <v-col cols="1">
      <DettaglioLotto :prodotto="prodotto" />
    </v-col>
  </v-row>
</template>

<script>
import conteggio_dettaglio_mixin from "../../mixin/conteggio_dettaglio_element_mixin";
import DettaglioLotto from "./conteggio_lotti.vue";
export default {
  components: {
    DettaglioLotto,
  },
  mixins: [conteggio_dettaglio_mixin],
};
</script>